import React, { Component } from 'react';
import {
    Container,
    Row, Col,
    Input, Button,
    InputGroup, InputGroupAddon,
    InputGroupText
} from 'reactstrap';
import 'react-widgets/dist/css/react-widgets.css';
import logo from '../../assets/img/brand/logo.png';

export default class LoginComponent extends Component {
    state = {
        email: '',
        password: '',
        titleButton: 'Ingresar',
    }
    componentDidUpdate = (prevState) => {
        if (!prevState.authSuccess && this.props.authSuccess ||
            !prevState.error && this.props.error) {
                this.setState({
                    titleButton: 'Ingresar',
                })
            }
    }
    onChangeEmail = (e) => {
        this.setState({ email: e.target.value });
    }
    onChangePassword = (e) => {
        this.setState({ password: e.target.value });
    }
    getInputValidation = (field) => {
        let props = {};
        if (this.props.error && this.props.error.getFields()[field]) {
            props.invalid = true;
        }
        return props;
    }
    save = () => {
        this.setState({ titleButton: 'Ingresando...' });
        this.props.onLogin(
            this.state.email,
            this.state.password
        );
    }
    render() {
        return (
            <Container>
                <img src={logo} width='140' height='auto' alt='Onecore Sales System'></img>
                <p className="text-muted">Ingresa a tu cuenta</p>
                <InputGroup className="mb-3">
                    <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                            <i className="icon-user"></i>
                        </InputGroupText>
                    </InputGroupAddon>
                    <Input onChange={this.onChangeEmail} type="text" id="email" placeholder="usuario@mail.com"
                        required value={this.state.email} {...this.getInputValidation('username')} />
                </InputGroup>
                <InputGroup className="mb-4">
                    <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                            <i className="icon-lock"></i>
                        </InputGroupText>
                    </InputGroupAddon>
                    <Input onChange={this.onChangePassword} type="password" id="password"
                        required value={this.state.password} {...this.getInputValidation('password')} />
                </InputGroup>
                <Row>
                    <Col xs="6">
                        <Button color="primary" className="px-4" onClick={this.save}>{this.state.titleButton}</Button>
                    </Col>
                    <Col xs="6">
                        <a href={process.env.REACT_APP_RESTORE_PASSWORD_URL} >Recuperar contraseña</a>
                    </Col>
                </Row>
            </Container>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Components/Login/LoginComponent.js